
























































































































































































































































































































































































































































































import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { Entry } from '@entries/interfaces/entry';
import EntryForm from '@entries/components/forms/entry-form/entry-form.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import BulkEditModal from '@shared/components/modals/bulk-edit-modal/bulk-edit-modal.vue';
import { setProp } from '@shared/helpers/operators';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import AdjustEntriesModal from '@entries/components/modals/adjust-entries-modal/adjust-entries-modal.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import AddPaymentModal from '@accounting/components/modals/add-payment-modal/add-payment-modal.vue';
import ModulesHelper from '@core/services/modules.helper';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
import ResyncFinddocProductModal from '@access-control/components/modals/resync-finddoc-product-modal/resync-finddoc-product-modal.vue';

library.add(faSync);

@Component({
  name: 'bpc-entry-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
    'bpc-bulk-edit-modal': BulkEditModal,
    'bpc-entry-form': EntryForm,
    'bpc-adjust-entries-modal': AdjustEntriesModal,
    'bpc-extended-filter': ExtendedFilter,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bc-add-payment-modal': AddPaymentModal,
    'bpc-resync-entries-modal': ResyncFinddocProductModal,
  },
})
export default class EntryTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    bulkEditModal: InstanceType<typeof BulkEditModal> & {
      saveBulkEdit(): void;
    };
    stdCancelForm: InstanceType<typeof EntryForm> & {
      formModel: any;
      formProvider: EntityFormProvider;
    };
    stdEntryForm: InstanceType<typeof EntryForm> & {
      formModel: any;
      saveEntity(): void;
      setEntityAttributesAfterSave(): void;
    };
  };
  @Prop({ type: String, default: 'default' }) readonly createFormConfigName: string;
  @Prop({ type: String, default: 'edit' }) readonly editFormConfigName: string;
  @Prop({ type: String, default: 'cancel-entries' }) readonly cancelFormConfigName: string;
  @Prop({ type: Array, default: () => ['part1', 'part2'] })
  declare readonly selectConfigName: string[];

  public entity: Entry = null;
  public entityName = 'entry';
  public pluralEntityName = 'entries';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionEntityNameToUse = 'entries';
  public selectedRowEntity = null;

  // Adjust entries data
  public showAdjustEntryModal: boolean = false;
  public currentEntry: Entry = null;
  // Add payment modal
  public showPaymentModal: boolean = false;

  // Resync modal data
  showResyncModal: boolean = false;

  closeResyncProgressBar() {
    if (this.isProcessingResyncEnded) {
      this.$store.dispatch('entryResyncStore/closeResyncProccess');
    }
  }

  resyncAlertKey: number = 0;

  mounted() {
    this.$root.$on('refresh-table-after-add-orders-to-pos', () => {
      this.refreshEntitiesAfterOrdersAddedToPosCheckout();
    });
    if (this.isFinddocAccessControlService) {
      this.listenToWebsocketEntryResyncChannel();
    }
  }

  destroyed() {
    this.$root.$off('refresh-table-after-add-orders-to-pos');
    if (this.isFinddocAccessControlService) {
      if (!this.isProcessingResyncRunning) {
        this.leaveWebsocketResyncChannel();
      }
    }
  }

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  public customRowActions = {
    downloadCard: {
      activated: true,
      type: 'action',
      icon: 'id-card',
      show: true,
      event: 'download-card',
      text: 'download-card',
      permissions: ['download'],
    },
  };

  public customPageActions = {
    resync: {
      activated: false,
      type: 'action',
      icon: 'sync',
      variant: 'primary',
      text: 'resync',
      show: false,
      event: 'resync',
      selectElements: true,
      tag: 'left',
      permissions: [],
    },
  };

  get pageActions() {
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  get entityId(): number | string {
    return this.entity ? this.entity.id : null;
  }

  get resyncAlertStatus(): string {
    if (this.isProcessingResyncRunning) {
      return 'warning';
    } else if (this.isProcessingResyncEnded) {
      return 'success';
    } else if (this.isProcessingResyncFailed) {
      return 'danger';
    } else {
      return 'info';
    }
  }

  get isProcessingResyncFailed(): boolean {
    return this.$store.getters['entryResyncStore/isProcessingResyncFailed'];
  }
  get isProcessingResyncEnded(): boolean {
    return this.$store.getters['entryResyncStore/isProcessingResyncEnded'];
  }
  get totalCount(): number {
    return this.$store.getters['entryResyncStore/totalCount'];
  }
  get processedCount(): number {
    return this.$store.getters['entryResyncStore/processedCount'];
  }
  get isProcessingResyncRunning(): boolean {
    return this.$store.getters['entryResyncStore/isProcessingResyncRunning'];
  }
  get isResyncClosed(): boolean {
    return this.$store.getters['entryResyncStore/isResyncClosed'];
  }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }

    this.customPageActions.resync.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.isFinddocAccessControlService;
  }

  customOnPageAction($event: string) {
    switch ($event) {
      case 'resync':
        this.onResync();
        break;
    }
  }

  /*
   *************************************************************
   */
  onResync() {
    this.showResyncModal = true;
    this.$bvModal.show('resync-modal');
  }

  onCloseResyncModal() {
    this.showResyncModal = false;
    this.$refs.provider.getEntities();
  }

  onStartProcessingResync() {
    this.resyncAlertKey = this.resyncAlertKey + 1;
    this.$store.dispatch('entryResyncStore/startResyncProcess');
    this.onCloseResyncModal();
  }

  listenToWebsocketEntryResyncChannel(): void {
    this.$bpcEcho
      .listenResyncEntryChannel()
      .listen('.BPC\\Entries\\Events\\EntryResyncStarted', data => {
        this.$store.dispatch('entryResyncStore/updateResyncStatus', {
          running: true,
          ended: false,
          failed: false,
          totalCount: data.totalCount || 0,
          processedCount: 0,
        });
      })
      .listen('.BPC\\Entries\\Events\\EntryResyncProcessed', data => {
        this.$store.dispatch('entryResyncStore/updateResyncStatus', {
          running: true,
          ended: false,
          failed: false,
          totalCount: data.totalCount || 0,
          processedCount: data.processedCount || 0,
          isResyncClosed: false,
        });
      })
      .listen('.BPC\\Entries\\Events\\EntryResyncEnded', data => {
        this.$store.dispatch('entryResyncStore/updateResyncStatus', {
          running: false,
          ended: true,
          failed: false,
          totalCount: data.totalCount || 0,
          processedCount: data.processedCount || 0,
          isResyncClosed: false,
        });

        this.$refs.provider.getEntities();
      });
  }

  leaveWebsocketResyncChannel(): void {
    this.$bpcEcho.leaveResyncEntryChannel();
  }

  /*
   *************************************************************
   */

  setEntityAttributesAfterSave() {
    this.$refs.stdEntryForm.setEntityAttributesAfterSave();
    this.showForm = true;
    this.showDrawerSection = true;
  }

  onFormSave() {
    if (this.entity.id) {
      this.$bvModal.show('confirmation-update-entry-row-modal');
    } else {
      //this.$refs.stdForm.saveEntity();
      this.nextAction = '';
      this.$refs.stdEntryForm.saveEntity();
    }
  }

  onFormSaveAndNew() {
    this.nextAction = 'new';
    this.$refs.stdEntryForm.saveEntity();
  }

  onConfirmRowUpdate() {
    this.$refs.stdEntryForm.formModel['update_orders'] = this.confirmUpdateOrderOptionSelected;
    this.$bvModal.hide('confirmation-update-entry-row-modal');
    //this.$refs.stdForm.saveEntity();
    this.$refs.stdEntryForm.saveEntity();
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'cancel':
        this.onOpenCancelRowModal($event.item);
        break;
      case 'download-card':
        this.downloadCard($event?.item?.item?.id);
        break;
    }
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.cancel.show =
      entity.status !== 'cancelled' &&
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$authorizationService.hasPermission('manage_entries');

    entity.actions.downloadCard.show =
      entity.status !== 'cancelled' &&
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      entity.print_with_card;
  }

  hasPermissionToCancel(): boolean {
    return this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse,
      'cancel',
    );
  }

  onOpenCancelRowModal(item) {
    this.selectedRowEntity = item.item;
    this.$bvModal.show('modal-cancel-entries');
  }

  onCloseCancelModal() {
    this.selectedRowEntity = null;
    this.$bvModal.hide('modal-cancel-entries');
  }

  onConfirmCancelRowModal() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('entry');
    const relativePath = '/cancel/' + this.selectedRowEntity.id;

    this.$bpcApi
      .put(basePath + relativePath, {
        id: this.selectedRowEntity.id,
        cancelOrders: this.$refs.stdCancelForm.formModel['cancel_orders'],
      })
      .subscribe(
        res => {
          this.selectedRowEntity = null;
          this.$refs.provider.getEntities();
          this.$bvModal.hide('modal-cancel-entries');
        },
        error => {
          this.selectedRowEntity = null;
          this.$bvModal.hide('modal-cancel-entries');
        },
      );
  }

  onOpenPaymentModal() {
    this.showPaymentModal = true;
  }

  onCloseAddpaymentModal() {
    this.showPaymentModal = false;
  }

  onPaymentCreated() {
    this.showPaymentModal = false;
    this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
    this.i++; // refresh form
    this.$refs.provider.getEntities(); // refresh table
  }

  async downloadCard(id: number | string) {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('entry');
    const relativePath = '/download-card/' + id;

    this.$bpcApi.postDownload(`${basePath + relativePath}`, '').subscribe();
  }

  get hasAccessControlModuleActivated() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACCESS_CONTROL_MODULE_NAME);
  }

  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get isInternalAccessControlService(): boolean {
    return this.accessControlConfig?.access_control_service === 'internal';
  }

  get isFinddocAccessControlService(): boolean {
    return this.accessControlConfig?.access_control_service === 'finddoc';
  }

  get showAddPaymentAction(): boolean {
    return (
      this.entity?.orders &&
      this.entity?.orders.some(
        order =>
          order.status === 'waiting' ||
          order.status === 'shopping_cart' ||
          order.status === 'invoiced' ||
          order.status === 'payment_process',
      )
    );
  }

  get showDownloadCardAction(): boolean {
    return (
      this.hasAccessControlModuleActivated &&
      this.entity?.entryCategory?.print_with_card &&
      this.entity?.accessControlBadge?.id &&
      this.entity?.entryCategory?.badge_type !== 'rfid'
    );
  }

  get showDropdownActions(): boolean {
    return this.entityId && (this.showDownloadCardAction || this.showAddPaymentAction);
  }

  get cancelModalTitle() {
    return this.$t('global.modals.bulk-cancel.title', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get cancelModalBody() {
    return this.$t('global.modals.bulk-cancel.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get entryFormConfigName() {
    if (this.entity) {
      return this.editFormConfigName ? this.editFormConfigName : this.formConfigName;
    } else {
      return this.createFormConfigName ? this.createFormConfigName : this.formConfigName;
    }
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;

  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }

  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }
  // Here, put the same fields as you put in dataToShowForBulkTrashedEntity in your entity Service
  bulkMoveToTrashDataToShow = [['date'], ['contact'], ['article']];

  // Bulk restore modal (recover)

  showBulkRecoverModal = false;

  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }

  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }

  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }

  bulkRecoverDataToShow = [['date'], ['contact'], ['article']];

  // Confirm bulk edit modal
  confirmUpdateOrderOptions: object[] = [
    {
      text: this.$t('global.modals.update-entry.multiple.orders.options.update'),
      value: 'update',
    },
    {
      text: this.$t('global.modals.update-entry.multiple.orders.options.no_update'),
      value: 'no_update',
    },
  ];
  confirmUpdateOrderOptionSelected: string = 'update';
  extraDataToBulkEdit: object = {};
  extraFieldsToBulkEdit: object = { defaultValueSwitchModel: {} };
  resetConfirmationUpdateModal() {
    this.confirmUpdateOrderOptionSelected = 'update';
  }

  onFormBulkSave() {
    this.$bvModal.show('confirmation-update-entry-modal');
  }

  onConfirmBulkSave() {
    setProp(this.extraFieldsToBulkEdit['defaultValueSwitchModel'], 'update_orders', false);
    setProp(
      this.extraDataToBulkEdit,
      'update_orders',
      this.confirmUpdateOrderOptionSelected === 'update',
    );
    this.$refs.bulkEditModal.saveBulkEdit();
  }

  onFinishBulkEdit() {
    this.$refs.provider.getEntities();
  }

  // Bulk edit modal
  showBulkEditModal = false;
  bulkEditDataToShow = [['date'], ['contact'], ['article']];
  onBulkEdit() {
    if (!this.emitOnBulkEdit) {
      this.showBulkEditModal = true;
    } else {
      this.$emit('on-bulk-edit', this.selection);
    }
  }
  onCloseBulkEdit() {
    this.showBulkEditModal = false;
  }

  openAdjustEntryModal(event) {
    this.currentEntry = this.$refs.stdEntryForm.formModel;
    this.showAdjustEntryModal = true;
  }
  onCloseShowAdjustEntryModal() {
    this.showAdjustEntryModal = false;
  }
  onAdjustedRemainingEntries($event) {
    this.i++; // Refresh stdForm
    this.$refs.provider.getEntities(); // refresh table
  }
}
